export interface ICountryData {
  readonly id?: number
  name: string
  continent?: string
}

export interface ICountry extends ICountryData {

  validate(): void
  update(data?: ICountryData): void
}

export const COUNTRY_NAME_MAX_LENGTH = 50
